<template>
    <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">รายงานลูกค้าทั้งหมดของระบบ</h1>
                <p
                    class="text-white pb-0 px-3"
                >แสดงรายชื่อลูกค้าทุกร้านค้า เพื่อให้สามารถจัดการลูกค้าแต่ละร้านได้</p>
            </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <div class="row justify-content-between">
                            <div class="col-12">
                                <h3 class="text-muted">ค้นหา</h3>
                                <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                                    <b-form-group class="mb-0" >
                                        <div class="row">
                                            <div class="col-6 col-md-6 col-lg-2">
                                                <input
                                                    type="text"
                                                    placeholder="ชื่อ"
                                                    class="form-control"
                                                    v-model="search.name"
                                                />
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-2 mb-3">
                                                <input
                                                    type="text"
                                                    placeholder="อีเมล์"
                                                    class="form-control"
                                                    v-model="search.email"
                                                />
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-2 mb-3">
                                                <input
                                                    type="text"
                                                    placeholder="เบอร์โทร"
                                                    class="form-control"
                                                    v-model="search.tel"
                                                />
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-2 mb-3">
                                                <input
                                                    type="text"
                                                    placeholder="เลขบัตรประชาชน"
                                                    class="form-control"
                                                    v-model="search.tax_id"
                                                />
                                            </div>
                                            <div class="col-12 col-md-3 col-lg-2">
                                                <button class="btn btn-info btn-sm-res" @click="getMemberCod()">
                                                <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-md-none d-lg-none" />
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- table -->
                    <div id="tablePrint">
                        <b-table
                            show-empty
                            responsive
                            :items="memberShop"
                            :fields="fields"
                            :per-page="search.perPage"
                            class="scroll-bar-pop text-center"
                            empty-text="ไม่มีข้อมูลลูกค้า"
                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        >
                            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
                            <template slot="shopCount" slot-scope="data">
                                <span  v-b-tooltip :title="data.item.shop.join(', ')">{{data.item.shopCount}}</span>
                            </template>
                            <template slot="status" slot-scope="data">
                                <span :class="`text-${statusMember(data.item.status).color}`">{{statusMember(data.item.status).title}}</span>
                                <h5 class="text-muted">{{data.item.remark}}</h5>
                            </template>
                            <template slot="manage" slot-scope="data">
                                <button class="btn btn-sm btn-primary px-3" @click="$router.push({name:'memberedit',params:{Id:data.item.memberId}})">
                                    แก้ไข
                                </button>
                            </template>
                        </b-table>
                        <div class="mt-3">
                            <b-pagination 
                                :total-rows="totalItem"
                                :current-page="search.page"
                                :per-page="search.perPage"
                                :value="search.page" 
                                @input="changePage"
                                align="right">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div> 
</template>
<script>
import validatePop from "../plugins/validatePop.js"
import { statusMember } from "../plugins/statusMember.js"
export default {
    name:"membercod",
    data(){
        return {
            busy: false,
            memberShop: [],
            search: {
                page: 1,
                perPage: 20,
                name: "",
                email: "",
                tel: "",
                tax_id: "",
            },
            totalItem: 0,
            statusMember: statusMember,
        }
    },
    mounted(){
        this.getMemberCod()
    },
    methods:{
        getMemberCod() {
            this.busy = true
            this.$http
                .post(this.$API_URL + "/shippop/member", {
                   ...this.search
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.handleLoader();
                    this.memberShop = res.data.data.data;
                    this.totalItem = res.data.data.totalItem;
                    
                });
        },
        handleLoader(){
            this.busy = !this.busy
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.getMemberCod()
        },
        getOverAllIndex(index){
            return ( this.search.page * 20 ) - 20 + index + 1
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "SUCCESS",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ตกลง",
            contentClass: "modal-success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "name", label: "ชื่อ", sortable: true },
                { key: "email", label: "อีเมล์", sortable: true },
                { key: "tel", label: "เบอร์โทร", sortable: true },
                { key: "tax_id", label: "เลขบัตรประชาชน", sortable: true },
                { key: "shopCount", label: "จำนวนร้านค้าที่ลงทะเบียน", sortable: true },
                { key: "status", label: "สถานะ", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>